export default function StatsCards({ medicines }) {
  const totalMedicines = medicines.length;

  const totalScans = medicines.reduce(
    (sum, med) => sum + (med.total_scans || 0),
    0,
  );

  const activeBatches = new Set(medicines.map((m) => m.batch_no)).size;

  const manufacturers = new Set(medicines.map((m) => m.manufacturer)).size;

  return (
    <div className="grid grid-cols-4 gap-6 mb-6">
      <div className="bg-white p-4 rounded-lg border">
        <p className="text-gray-500 text-sm">Total Medicines</p>
        <h2 className="text-2xl font-semibold">{totalMedicines}</h2>
      </div>

      <div className="bg-white p-4 rounded-lg border">
        <p className="text-gray-500 text-sm">Total QR Scans</p>
        <h2 className="text-2xl font-semibold">{totalScans}</h2>
      </div>

      <div className="bg-white p-4 rounded-lg border">
        <p className="text-gray-500 text-sm">Active Batches</p>
        <h2 className="text-2xl font-semibold">{activeBatches}</h2>
      </div>

      <div className="bg-white p-4 rounded-lg border">
        <p className="text-gray-500 text-sm">Manufacturers</p>
        <h2 className="text-2xl font-semibold">{manufacturers}</h2>
      </div>
    </div>
  );
}
